import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

function Foundation(props) {
  function openLink(link) {
    window.open(link, "_blank");
  }

  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-foundation").focus();
  }, []);

  return (
    <section className="section-foundation">
      <a id="title-foundation" className="title-home" tabIndex={12}>
        Página Expo Área - NTT Data Foundation
      </a>
      <div className="div-cards-foundation">
        {/* <div className="card-foundation">
          <a
            className="title-card-foundation"
            id="title-card-foundation"
            tabIndex={13}
          >
            Albúm de Fotos
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf Albúm de Fotos"
            tabIndex={14}
            id="foundation-link1"
            onClick={() => {
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20NTT%20DATA%20FOUNDATION/%C3%81lbum%20fotos%20NTT%20DATA%20FOUNDATION.pdf?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=1698240824&Signature=%2BlhaxYsjuyw9ulHUf2xWCChnBgU%3D"
              );
              pointAction("FUNDACAONTTPDFALBUMDEFOTOS");
            }}
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
            />
          </button>
        </div> */}

        <div className="card-foundation">
          <a
            className="title-card-foundation"
            id="title-card-foundation"
            tabIndex={15}
          >
            Forms
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Abrir página de formulário para Voluntariado NTT DATA"
            tabIndex={16}
            id="foundation-link2"
            onClick={() => {
              openLink(
                "https://forms.office.com/Pages/ResponsePage.aspx?id=h9xIMPBDAEGay64ZcceTldwg25U5zfdJq-gK1mK54i9UNzY0Qzk1UVRNNlJUVjlaS1JBSVNYT1FTRi4u"
              );
              pointAction("FUNDACAONTTPESQUISAFORMS");
            }}
          >
            <i
              className="bx bx-link-external"
              style={{ fontSize: 40, cursor: "pointer" }}
            />
          </button>
        </div>

        <div className="card-foundation">
          <a
            className="title-card-foundation"
            id="title-card-foundation"
            tabIndex={17}
          >
            NTT DATA Fundation
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Abrir página Site NTT DATA Fundation"
            tabIndex={18}
            id="foundation-link1"
            onClick={() => {
              openLink("https://www.nttdatafoundation.com/br");
              pointAction("FUNDACAONTTSITEFOUNDATION");
            }}
          >
            <i
              className="bx bx-link-external"
              style={{ fontSize: 40, cursor: "pointer" }}
            />
          </button>
        </div>

        <div className="card-foundation">
          <a
            className="title-card-foundation"
            id="title-card-foundation"
            tabIndex={19}
          >
            Vídeo Antônio
          </a>
          <video
            width={250}
            controls
            tabIndex={20}
            onPlay={() => pointAction("FUNDACAONTTVIDEOANTONIO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_fundacao/%C3%81reas%20Expo%20-%20Funda%C3%A7%C3%A3o%20NTT%20DATA%20%28ANT%C3%94NIO%29%20V2%20%281%29.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Foundation);
